module.exports = __webpack_public_path__ + "static/img/xiang.72929e85.png";